/**
 * Whether a keyboard event started inside an open dialog. A dialog is portaled out of the page it was opened
 * from, but its key events still bubble to `window`, so a page-wide shortcut handler must check this to leave
 * the dialog's own controls alone.
 */
export function isInsideDialog(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest('[role="dialog"], [role="alertdialog"]') !== null;
}
